import { ModalsContextProps } from 'context';

import {
  Feedback,
  Confirm,
  AddOrViewNote,
  AssessmentAnswers,
  DeliverContent,
  PublishedProfile,
  Discharge,
  CalendarEvent,
  ChatListModal,
  DocDownload,
  Forward,
  DeviceWarning,
} from 'modals';
import CancelEventMobile from 'modals/CancelEventMobile';

const modalsConfig: ModalsContextProps['Modals'] = {
  feedback: {
    Component: Feedback,
    isOpen: false,
  },
  docDownload: {
    Component: DocDownload,
    isOpen: false,
  },
  confirm: {
    Component: Confirm,
    isOpen: false,
  },
  forward: {
    Component: Forward,
    isOpen: false,
  },
  addOrViewNote: {
    Component: AddOrViewNote,
    isOpen: false,
  },
  assessmentAnswers: {
    Component: AssessmentAnswers,
    isOpen: false,
  },
  deliverContent: {
    Component: DeliverContent,
    isOpen: false,
  },
  chatListModal: {
    Component: ChatListModal,
    isOpen: false,
  },
  publishedProfile: {
    Component: PublishedProfile,
    isOpen: false,
  },
  discharge: {
    Component: Discharge,
    isOpen: false,
  },
  calendarEvent: {
    Component: CalendarEvent,
    isOpen: false,
  },
  deviceWarning: {
    Component: DeviceWarning,
    isOpen: false,
  },
  cancelEventMobile: {
    Component: CancelEventMobile,
    isOpen: false,
  },
};

export default modalsConfig;
